import { BenefitsDesktopComposition } from './desktop-composition';
import { BenefitsMobileCarousel } from './mobile-carousel';

export function BenefitsSection() {
    return (
        <div className="w-full relative mt-16 md:mt-24">
            <BenefitsDesktopComposition />
            <BenefitsMobileCarousel />
        </div>
    );
}
